import { http } from '@/core/helpers/http.helper';
import { ApiResource } from './../../../models/api-resource.interface';
import { Communication } from './../../communications/communication.interface';
export class SmsService {
   async inviteToVideoRoom(candidateId: number, videocallRoomId: number) {
      const response = await http.get<ApiResource<Communication>>(`/candidates/${candidateId}/video-room/${videocallRoomId}/invite`);
      return response.data;
   }
}
